<script lang="ts" context="module">
	declare const jQuery: any;
</script>

<script lang="ts">
	import { onMount } from 'svelte';
	import { CONTACT_EMAIL, CONTACT_PHONE } from '$lib/contact';
	import { SITE_DISPLAY_NAME, SITE_DOMAIN } from '$lib/constants';

	const YEAR = new Date().getFullYear();

	function resizeFooter() {
		jQuery('.footer-height').css('height', jQuery('#footer-fixed').height());
	}

	onMount(() => {
		/* ===== Fixed Footer ===== */
		jQuery('<div class="footer-height"></div>').insertAfter('#footer-fixed');
		jQuery(window).on('resize', resizeFooter).trigger('resize');

		// onDestroy equivalent - using this since it should only run client side
		return () => {
			jQuery(window).off('resize', resizeFooter);
		};
	});
</script>

<footer class="footer dark-block" id="footer-fixed">
	<div class="footer-main">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-3 col-md-3 col-md-offset-2">
					<div class="widget widget-text text-center">
						<div class="logo logo-footer">
							<a href="/">
								<img class="logo logo-display" src="/assets/images/logo-light.webp" alt="" /></a
							>
						</div>
					</div>
				</div>
				<div
					class="col-xs-10 col-xs-offset-1 mt-xs-70 mt-sm-70 col-sm-6 col-md-5 col-md-offset-1 mt-md-70"
				>
					<div class="widget widget-text">
						<div class="widget-links">
							<h5 class="widget-title text-center-xs text-center-sm">Contact</h5>
							<ul>
								<li>
									<span aria-hidden="true" class="icon icon-phone" />
									<a href="tel:{CONTACT_PHONE.number}">{CONTACT_PHONE.display}</a>
								</li>
								<li>
									<span aria-hidden="true" class="icon ion-email" />
									<a href="mailto:{CONTACT_EMAIL}">{CONTACT_EMAIL}</a>
								</li>
								<li>
									<span aria-hidden="true" class="icon icon-laptop" />
									<a href="https://{SITE_DOMAIN}">{SITE_DOMAIN}</a>
								</li>
								<li>
									<span aria-hidden="true" class="icon ion-android-people" />
									<!-- svelte-ignore a11y-missing-content -->
									<a
										href="https://facebook.com/genesisoutdoorliving"
										target="_blank"
										rel="noopener noreferrer"
										class="social-link ion-social-facebook"
									/>
									<!-- svelte-ignore a11y-missing-content -->
									<a
										href="https://instagram.com/genesisoutdoorlivingnc?igshid=OGQ5ZDc2ODk2ZA=="
										target="_blank"
										rel="noopener noreferrer"
										class="social-link ion-social-instagram"
									/>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="footer-copyright">
		<div class="container">
			<div class="row">
				<div class="col-md-6 col-sm-8 col-xs-11 col-xs-offset-1">
					<div class="copy-right text-left">
						&copy; {YEAR}
						{SITE_DISPLAY_NAME}. All rights reserved.
					</div>
					<div class="copy-right text-left">
						Created and hosted by <a
							target="_blank"
							rel="noreferrer"
							href="https://theoretically.co"
						>
							Theoretically Inc.
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>

<style lang="scss">
	@import 'src/lib/scss/colors';

	.footer .widget-links a:hover,
	.footer-copyright a:hover {
		color: $green;
	}

	img.logo.logo-display {
		height: 120px;
		width: auto;
		margin: auto;
		max-width: none;
		max-height: none;
	}

	.logo img {
		max-height: none;
	}

	.icon {
		display: inline-block;
		padding-right: 20px;
		width: 40px;
		text-align: center;
	}

	h5 {
		margin-left: 10px;
	}

	.social-link {
		margin: 0px 15px;
		font-size: 20px;
	}

	.copy-right {
		text-align: left;
		margin-bottom: 0px;
	}

	@media (min-width: 481px) and (max-width: 766px) {
		.text-center-sm {
			text-align: center;
		}

		footer.dark-block .widget-title::before {
			border-top: none;
		}

		.mt-sm-70 {
			margin-top: 70px;
		}

		.footer .widget-title {
			margin-bottom: 20px;
		}
	}

	@media (min-width: 320px) and (max-width: 480px) {
		.text-center-xs {
			text-align: center;
		}

		footer.dark-block .widget-title::before {
			border-top: none;
		}

		.mt-xs-70 {
			margin-top: 70px;
		}
	}
</style>
